import { cookieHelper } from "@/common/CookieHelper";
import axios from "axios";
 
interface ApiResponse {
  code: number;
  data: any;
  msg: string;
  status: boolean;
}
// var baseURL = "http://localhost:5137/";

class AxiosHelper {
  private baseUrl: string;
  /**
   *
   */
  constructor() {
    this.baseUrl = "/";
    axios.defaults.withCredentials = true;
    // 限制访问次数，防止无线循环访问

    let i = 0;
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        ;

        if (error?.status === 401) {
          console.log("📥 [响应拦截器成功qqq]", error);
          // Token 失效，清除本地存储并跳转到登录页
          cookieHelper.delCookie("Userid");
          cookieHelper.delCookie("shopid");
          cookieHelper.delCookie("shopname");
          cookieHelper.delCookie("telPhone");
          cookieHelper.delCookie("username");
          cookieHelper.delCookie("refreshToken");

          cookieHelper.delCookie("token");
       
          //   localStorage.removeItem('user');

          //如果不是登录页，则跳转
           window.location.href = "/#/login";
        //   if (!window.location.pathname.includes("/login")) {
        //     window.location.href = "/#/login";
        //   }
          return Promise.resolve({ data: { success: false } });
        }
        return Promise.reject(error);
      },
    );

    axios.interceptors.response.use(async (res: any) => {
        
         
            console.log('📥res.status ', res)
        if (res.status == 203) {
            if (i++ <= 0) {
                // 重新请求RefreshToken接口，去刷新token
                var rToken = await (await this.useWebAPI()).getH({
                    url: "app/User/RefreshToken"
                })
                // 如果结果不为空则将新的token返回
                if (rToken != null) {
                    // 将返回的token写入cookie
                    cookieHelper.setCookie("token", rToken.data)
                    // 清空baseURL因为res.request.responseURL记录着完整的请求地址
                    this.baseUrl = "";
                    // 从cookie中获取token并加入到请求头中
                    await this.getCookie();
                    // 请求之前请求失败的地址
                    await this.get({
                        url: res.request.responseURL
                    })
                }
            }
        }
//         if (res.status === 401) {
//         // 清除本地存储的认证信息
//         localStorage.removeItem('token');
//         localStorage.removeItem('user');
// //  window.location.href = "/#/login";
//         // 可以添加提示

//         // 或者刷新 token（如果有刷新token机制）
//         // refreshToken();
//     }
        return res;
    } )
  }

  async useWebAPI(apiRootKey: string = "Default") {
    await this.getCookie();
    this.baseUrl = await this.getValue(apiRootKey);
    return this;
  }
  async useLocal() {
    this.baseUrl = await this.getValue("Local");
    return this;
  }
  async post(data: any) {
    var res = await axios.post(`${this.baseUrl}${data.url}`, data.params);
    return res;
  }
  async get(data: any) {
    var res = await axios.get(`${this.baseUrl}${data.url}`, {
      params: data.params,
    });
    return res;
  }
  async getH(data: any) {
    var res = await axios.get<ApiResponse>(`${this.baseUrl}${data.url}`, {
      params: data.params,
    });
    return res.data;
  }
  async put(data: any) {
    var res = await axios.put(`${this.baseUrl}${data.url}`, data.params);
    return res;
  }
  async deleted(data: any) {
    var res = await axios.delete(`${this.baseUrl}${data.url}`, {
      params: data.params,
    });
    return res;
  }
    async Alldeleted(data: any,jsonString:any) {
     const url = `${this.baseUrl}${data.url}s${jsonString}`
     console.log(url)
     const res = await axios.delete(url)
    return res;
  }
  /**
   * 从cookie中获取token并加入到请求头中
   */
  async getCookie() {
    var token = cookieHelper.getCookie("token");
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
  async getValue(key: string) {
    var resStr = sessionStorage["apiRootKey"];
    if (resStr == null) {
      let res = await axios.get("/appsettings.json");
      sessionStorage["apiRootKey"] = JSON.stringify(res.data);
      return res.data["ApiRoots"][key];
    } else {
      let res = JSON.parse(resStr);
      return res["ApiRoots"][key];
    }
  }
}

export const superAxios = (function () {
  return new AxiosHelper();
})();

// export const post = async (data: any) => {
//     var res = await axios.post(`${baseURL}${data.url}`, data.params)
//     return res.data
// }
// export const get = async (data: any) => {
//     var res = await axios.get(`${baseURL}${data.url}`, { params: data.params });
//     return res.data;
// }
// export const put = async (data: any) => {
//     var res = await axios.put(`${baseURL}${data.url}`, data.params);
//     return res.data;
// }
// export const deleted = async (data: any) => {
//     var res = await axios.delete(`${baseURL}${data.url}`, { params: data.params });
//     return res.data;
// }

// const vailidateCode = (res : any)=>{
//     if(res.status = 200)
// }
